export const getTestDriveIframeLink = (modelId: number) => {
  switch (modelId) {
    case 21:
      return "https://yoman.co.il/sites/67bc7776-71a6-4e11-a839-5ba94be3b6b6/b5UxgxdPhU?sitesGroupID=MAZ&RGP=MAZDA 2&langbar=0"
    case 2:
    case 3:
      return "https://yoman.co.il/sites/67bc7776-71a6-4e11-a839-5ba94be3b6b6/b5UxgxdPhU?sitesGroupID=MAZ&RGP=MAZDA 3&langbar=0"
    case 17:
      return "https://yoman.co.il/sites/67bc7776-71a6-4e11-a839-5ba94be3b6b6/b5UxgxdPhU?sitesGroupID=MAZ&RGP=MAZDA CX 3&langbar=0"
    case 6:
      return "https://yoman.co.il/sites/67bc7776-71a6-4e11-a839-5ba94be3b6b6/b5UxgxdPhU?sitesGroupID=MAZ&RGP=MAZDA CX 30&langbar=0"
    case 12:
      return "https://yoman.co.il/sites/67bc7776-71a6-4e11-a839-5ba94be3b6b6/b5UxgxdPhU?sitesGroupID=MAZ&RGP=MAZDA CX5&langbar=0"
    case 13:
      return "https://yoman.co.il/sites/67bc7776-71a6-4e11-a839-5ba94be3b6b6/b5UxgxdPhU?sitesGroupID=MAZ&RGP=MAZDA 6&langbar=0"
    default:
      return "https://yoman.co.il/sites/67bc7776-71a6-4e11-a839-5ba94be3b6b6/b5UxgxdPhU?sitesGroupID=MAZ&langbar=0"
  }
}
export const getMeetingIframeLink = (modelId: number) => {
  switch (modelId) {
    case 21:
      return "https://yoman.co.il/sites/67bc7776-71a6-4e11-a839-5ba94be3b6b6/3T791irzH0?sitesGroupID=MAZ&RG=MAZDA 2&langbar=0"
    case 2:
    case 3:
      return "https://yoman.co.il/sites/67bc7776-71a6-4e11-a839-5ba94be3b6b6/3T791irzH0?sitesGroupID=MAZ&RG=MAZDA 3&langbar=0"
    case 17:
      return "https://yoman.co.il/sites/67bc7776-71a6-4e11-a839-5ba94be3b6b6/3T791irzH0?sitesGroupID=MAZ&RG=MAZDA CX 3&langbar=0"
    case 6:
      return "https://yoman.co.il/sites/67bc7776-71a6-4e11-a839-5ba94be3b6b6/3T791irzH0?sitesGroupID=MAZ&RG=MAZDA CX 30&langbar=0"
    case 12:
      return "https://yoman.co.il/sites/67bc7776-71a6-4e11-a839-5ba94be3b6b6/3T791irzH0?sitesGroupID=MAZ&RG=MAZDA CX5&langbar=0"
    case 13:
      return "https://yoman.co.il/sites/67bc7776-71a6-4e11-a839-5ba94be3b6b6/3T791irzH0?sitesGroupID=MAZ&RG=MAZDA 6&langbar=0"
    default:
      return "https://yoman.co.il/sites/67bc7776-71a6-4e11-a839-5ba94be3b6b6/3T791irzH0?sitesGroupID=MAZ&langbar=0"
  }
}

export const isModelHasTestDriveIframe = (modelId: number) => {
  return [21, 2, 3, 17, 6, 12, 13].includes(modelId)
}
export const isModelHasMeetingIframe = (modelId: number) => {
  return [21, 2, 3, 17, 6, 12, 13].includes(modelId)
}
